import { CustomChannelResponse } from './model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<CustomChannelResponse> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<CustomChannelResponse> = createEntityAdapter<CustomChannelResponse>({
  selectId: (item) => item.pkey,
  sortComparer: false,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
